import script from "./FooterMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterMenu.vue?vue&type=script&setup=true&lang=js"

import "./FooterMenu.vue?vue&type=style&index=0&id=7257df2e&lang=css"

const __exports__ = script;

export default __exports__